import React from "react"
// import { createControlledLayer } from "react-leaflet/types/LayersControl"

import {
  Card,
  CardBody,
  Col,
  Row,
  CardTitle,
  Form,
  Container,
  Label,
  Input,
  FormGroup,
  Button
} from "reactstrap"

//Import Breadcrumb
// import Breadcrumbs from "../../components/Common/Breadcrumb"

// import Select from "react-select"

import PromoFormMerchant from "../../components/MerchantComponents/PromoFormMerchant"

const MerchantUpdateCode = (props) => {

    let promoData = {
      promoCode: props.location.state.code,
      discountType: props.location.state.type,
      amount: props.location.state.amount,
      merchant: props.location.state.merchant,
      usagelimit: props.location.state.usagelimit,
      stDate: props.location.state.stDate,
      endDate: props.location.state.endDate,
      stTime: props.location.state.stTime,
      endTime: props.location.state.endTIme,
      endDate: props.location.state.expDate,
      status: props.location.state.status,
      category: props.location.state.category,
      product: props.location.state.product,
      paymentMethod: props.location.state.paymentMethod
      }
    
  return (
    <React.Fragment>
          <PromoFormMerchant data={promoData} updateCode={true}/>
    </React.Fragment>
  )
}

export default MerchantUpdateCode;
